var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-image",style:({
    borderRadius: _vm.borderRadius,
  })},[_c('img',{style:({
      borderRadius: _vm.borderRadius,
    }),attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.width}})])
}
var staticRenderFns = []

export { render, staticRenderFns }